import { hasFullSettingsAccess, userCapabilities } from '@/composables/useSettingsAccess'
import { buildSettingsTabs, firstSettingsPath } from '@/config/settingsTabs'
import { showsSearchAndAi } from '@/helpers/aiReadableStorefront'

export const buildSearchAndAiGuard = getUser => () => {
  const access = { hasFullAccess: hasFullSettingsAccess(), capabilities: userCapabilities(getUser()) }
  return showsSearchAndAi(access) ? true : firstSettingsPath(buildSettingsTabs(access))
}
